// extracted by mini-css-extract-plugin
module.exports = {"popupFieldComponent":"Claims_popupFieldComponent__AM6XF","contactDetailsLink":"Claims_contactDetailsLink__zPMbl"};